import React, { Component } from 'react';
import { Provider } from 'react-redux';

import './App.css';

import ButtonPad from './components/button-pad/ButtonPad';
import ControlPad from './components/control-pad/ControlPad';

import store from './store';

class App extends Component {
  render() {
    return (
	<Provider store={store}>
      <div className="App">
	  	<div className="container">
			<ButtonPad />
			<ControlPad />
		</div>
      </div>
	
	</Provider>
    );
  }
}

export default App;
